import { Box, Button, Flex } from '@theme-ui/components'
import { useState } from 'react'
import { match, __ } from 'ts-pattern'
import { ReportAction } from '../../../@types/report-action'
import { Modal } from '../../../components'
import Dropdown, {
  DropdownButton,
  DropdownList,
  DropdownMenu,
} from '../../../components/Dropdown/Dropdown'
import RichTextEditor from '../../../components/RichTextEditor/RichTextEditor'

export default function VerificatorActions({
  onConfirm,
  reportType,
}: {
  onConfirm(action: ReportAction, payload?: any): Promise<any>
  reportType?: string
}) {
  const [action, setAction] = useState<ReportAction>('NONE')
  const [loading, setLoading] = useState(false)
  const [remarks, setRemarks] = useState('')

  function handleConfirm(payload = {}) {
    setLoading(true)
    onConfirm(action, payload)
      .then(() => {
        setLoading(false)
        setAction('NONE')
        setRemarks('')
      })
      .catch(() => setLoading(false))
  }

  function handleReturnToWhistleblower(e) {
    e.preventDefault()
    handleConfirm({ remarks })
  }

  const disabled = match([loading, action, remarks])
    .with([true, __, __], () => true)
    .with([__, 'RETURN_TO_WHISTLEBLOWER', ''], () => true)
    .otherwise(() => false)

  return (
    <>
      <Dropdown placement="top-end">
        <DropdownButton>Tindakan</DropdownButton>
        <DropdownList>
          <DropdownMenu onClick={() => setAction('SEND_TO_REVIEWER')}>
            Diteruskan ke UP2
          </DropdownMenu>
          {reportType === 'tindak_pidana_korupsi' && (
            <DropdownMenu onClick={() => setAction('SEND_TO_HONOR_BOARD')}>
              Diteruskan ke Dewan Kehormatan
            </DropdownMenu>
          )}
          {reportType === 'non_tindak_pidana_korupsi' && (
            <DropdownMenu onClick={() => setAction('HANDOVER_TO_KPK')}>
              Diteruskan ke KPK
            </DropdownMenu>
          )}
          <DropdownMenu onClick={() => setAction('RETURN_TO_WHISTLEBLOWER')}>
            Kembali ke Pelapor
          </DropdownMenu>
          <DropdownMenu onClick={() => setAction('ARCHIVE')}>
            Arsipkan
          </DropdownMenu>
        </DropdownList>
      </Dropdown>
      <Modal
        isOpen={action !== 'NONE'}
        onRequestClose={() => setAction('NONE')}
        header={`Anda yakin untuk ${match(action)
          .with('SEND_TO_REVIEWER', () => 'kirim ke UP2?')
          .with('SEND_TO_HONOR_BOARD', () => 'kirim ke Dewan Kehormatan?')
          .with('HANDOVER_TO_KPK', () => 'kirim ke KPK?')
          .with('RETURN_TO_WHISTLEBLOWER', () => 'kembali ke whistleblower?')
          .with('ARCHIVE', () => 'arsipkan?')
          .otherwise(() => '')}`}
      >
        {match(action)
          .with('NONE', () => null)
          .with('RETURN_TO_WHISTLEBLOWER', () => (
            <Box>
              <form action="" onSubmit={handleReturnToWhistleblower}>
                <label htmlFor="">Remarks</label>
                <RichTextEditor
                  placeholder="tulis informasi apa saja yang kurang dari whistleblower"
                  value={remarks}
                  onChange={(data) => setRemarks(data)}
                />
                <Button
                  type="submit"
                  sx={{ display: 'block', ml: 'auto', mt: 2 }}
                  disabled={disabled}
                >
                  Kirim
                </Button>
              </form>
            </Box>
          ))
          .with(__, () => (
            <Flex sx={{ justifyContent: 'end' }}>
              <Button
                variant="secondary"
                mr="2"
                onClick={() => setAction('NONE')}
              >
                Tidak
              </Button>
              <Button px={4} onClick={handleConfirm} disabled={loading}>
                Ya
              </Button>
            </Flex>
          ))
          .exhaustive()}
      </Modal>
    </>
  )
}
